import api from "./api.js"
export const apiLogin = async (userDetail) => {
  const params = new URLSearchParams();
  params.append("email", userDetail.email);
  params.append("pwd", userDetail.password);
  params.append("platform", "camp");

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("auth/login", params, config);

  return data;
};

export const apiRegister = async (userDetail) => {
  const params = new URLSearchParams();
  params.append("first_name", userDetail.first_name);
  params.append("last_name", userDetail.last_name);
  params.append("email", userDetail.email);
  params.append("phone", userDetail.cell_phone);
  params.append("password", userDetail.password);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("auth/register", params, config);

  return data;
};
export const apiVerifySignup = async (userDetail) => {
  const params = new URLSearchParams();
  params.append("code", userDetail.code);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("auth/register_email_verify", params, config);

  return data;
};
export const apiForgotPassword = async (userDetail) => {
  const params = new URLSearchParams();
  params.append("email", userDetail.email);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("auth/password_reset_email", params, config);

  return data;
};
export const apiConfirmCode = async (userDetail) => {
  const params = new URLSearchParams();
  params.append("verify_code", userDetail.code);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("auth/password_reset_confirm", params, config);

  return data;
};

export const apiChangePassword = async (userDetail) => {
  const params = new URLSearchParams();
  params.append("token", userDetail.token);
  params.append("new_pass", userDetail.password);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("auth/change_password", params, config);

  return data;
};